import React from 'react';

import Spinner from '@components/Spinner';
import useNewsletterDetailByIds from '@hooks/useNewsletterDetailByIds';

import NewsletterCards from './NewsletterCards';
import MyTISection from './Section';

const MyTINewsletters = ({ recommendedNewsletters }) => {
  const { newsletters, isLoadingNewsletters } = useNewsletterDetailByIds({
    newsletter_ids: [1, 2, 12, 137],
    // TODO FIXME recommendedNewsletters,
    // Coming in subsequent PRs
  });

  return (
    <MyTISection
      highlight="Label"
      subtitle="Lorem ipsum dolor sit amet consectetur adipisicing elit"
      title="Newsletters"
    >
      {!isLoadingNewsletters ? (
        <div className="mt-32 flex w-full flex-row flex-wrap justify-center gap-20 md:grid md:grid-cols-4">
          <NewsletterCards newsletters={newsletters} />
        </div>
      ) : (
        <div className="grid w-full place-items-center">
          <Spinner marginY="small" />
        </div>
      )}
    </MyTISection>
  );
};

export default MyTINewsletters;
